<template>
  <div>
    <div  class="border b-radius-4" style="padding: 6px">
      <el-form>
        <el-row v-if="showConfig" :gutter="10" style="margin-bottom: 2px">
          <el-col :span="12">
            <el-form-item >
              <el-input v-model="oldText" type="textarea" :autosize="{minRows: 4, maxRows: 4}"
                        placeholder="请输入对比数据1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item >
              <el-input v-model="newText" type="textarea" :autosize="{minRows: 4, maxRows: 4}"
                        placeholder="请输入对比数据2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="border b-radius-4" style="padding: 0 6px;margin: 0 2px">
          <el-col :span="14">
            <el-form-item label="展示效果：">
              <el-switch v-model="fotmat" active-text="line-by-line" inactive-text="side-by-side"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="2" style="float:right; text-align:right; margin-right">
            <el-form-item >
              <el-button size="mini" type="text" @click="handleClearLocalStorage" style="margin-left: 10px">清空数据</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <code-diff
      :old-string="formatoldText"
      :new-string="formatnewText"
      :context="context"
      :output-format="outputFormat"
      :drawFileList="drawFileList"
      :renderNothingWhenEmpty="renderNothingWhenEmpty"
      :diffStyle="diffStyle"
      :isShowNoChange="isShowNoChange"
    />
	<div class="footer"><span>{{footer}}</span><el-link :href='beianLink'> {{beian}} </el-link><span><template v-for="(item,index) in links"><el-link :href='item.href' :key="index"> {{item.name}} </el-link></template></span></div>
  </div>
</template>

<script>
import codeDiff from './lib/index.js'

export default {
  name: 'App',
  components: {
    codeDiff
  },
  data () {
    return {
      showConfig: true,
      oldText: '',
      newText: '',
      fotmat: false,
      context: 10000,
      diffStyle: 'word',
      isShowNoChange: true,
      drawFileList: false,
      renderNothingWhenEmpty: false,
      changeLineChar: '且',
      footer: '',
      links: window.g.links,
      beian: window.g.beian,
      beianLink: window.g.beianLink
    }
  },
  computed: {
    outputFormat () {
      return this.fotmat ? 'line-by-line' : 'side-by-side'
    },
    formatoldText () {
      let newValue = ''
      if (this.changeLineChar !== null && this.changeLineChar !== '') {
        for (let cellChar of this.oldText) {
          newValue = newValue + cellChar
          if (cellChar === this.changeLineChar) {
            newValue = newValue + '\n'
          }
        }
        return newValue
      } else {
        return this.oldText
      }
    },
    formatnewText () {
      let newValue = ''
      if (this.changeLineChar !== null && this.changeLineChar !== '') {
        for (let cellChar of this.newText) {
          newValue = newValue + cellChar
          if (cellChar === this.changeLineChar) {
            newValue = newValue + '\n'
          }
        }
        return newValue
      } else {
        return this.newText
      }
    }
  },
  watch: {
    oldText (v) {
      localStorage.setItem('oldText', v)
    },
    newText (v) {
      localStorage.setItem('newText', v)
    }
  },
  created () {
    localStorage.removeItem('oldText')
    localStorage.removeItem('newText')
    this.oldText = ''
    this.newText = ''
  },
  mounted () {
    this.getFooter()
  },
  methods: {
    getFooter () {
      this.footer = window.g.footer + window.g.webTitle + '(' + window.g.webLink + ')'
    },
    handleClearLocalStorage (e) {
      e.stopPropagation()
      this.newText = ''
      this.oldText = ''
      localStorage.setItem('newText', '')
      localStorage.setItem('oldText', '')
    },
    descInput () {
    }
  }
}
</script>
<style>
.el-form-item {
  margin-bottom: 2px !important;
}

.title {
  padding: 4px 0 4px 0;
  font-size: 24px;
  font-weight: 700;
  color: cornflowerblue;
  font-family: "Comic Sans MS", cursive, sans-serif;
  text-align: center;
}
.footer{
  text-align:center;
  color:#999
}
.footer span{
  font-size: 13px;
  color:#aaa;
  margin:0 3px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue